import $ from "jquery"
import ScrollMagic from 'scrollmagic';

$(window).on('load', function() {
  if ($('#developers-trigger').length > 0 && $(window).width() > 767) {
    var controller = new ScrollMagic.Controller()
    var duration = $('.section--scroll').first().height() - $('#slides-scroll4').height() - 100
    var offsetVal = 307

    if ($(window).width() < 1600) {
      offsetVal = 200
    }

    if ($(window).width() < 1199) {
      offsetVal = 250
    }

    if ($(window).width() < 992) {
      offsetVal = 350
    }

    var scene = new ScrollMagic.Scene({triggerElement: '#developers-trigger', offset: offsetVal, duration: duration})
      .setPin('#slides-scroll4', {pushFollowers: false})
      .addTo(controller)

    var scene1 = new ScrollMagic.Scene({triggerElement: '#symfony-developers', duration: $('#symfony-developers').height()})
      .addTo(controller)
      .on('enter', myFunction)

    var scene2 = new ScrollMagic.Scene({triggerElement: '#oxid-developers', duration: $('#oxid-developers').height()})
    .addTo(controller)
    .on('enter', myFunction2)
    
    var scene3 = new ScrollMagic.Scene({triggerElement: '#wordpress-developers', duration: $('#wordpress-developers').height()})
      .addTo(controller)
      .on('enter', myFunction3)

    var scene4 = new ScrollMagic.Scene({triggerElement: '#php-developers', duration: $('#php-developers').height()})
      .addTo(controller)
      .on('enter', myFunction4)

    var scene5 = new ScrollMagic.Scene({triggerElement: '#fullstack-developers', duration: $('#fullstack-developers').height()})
      .addTo(controller)
      .on('enter', myFunction5)

    var scene6 = new ScrollMagic.Scene({triggerElement: '#react-developers', duration: $('#react-developers').height()})
      .addTo(controller)
      .on('enter', myFunction6)
    
    var scene7 = new ScrollMagic.Scene({triggerElement: '#javascript-developers', duration: $('#javascript-developers').height()})
      .addTo(controller)
      .on('enter', myFunction7)

    var k = 'scene';
    var i = 0;

    $('.developers-step__item--desktop').each(function () {
      i++;
      var thisEl = $(this)
      var block = $(this).attr('id');
      var block2 = '#'+block
      var numb = i;

      new ScrollMagic.Scene({triggerElement: block2, duration: $(block2).height()}).addTo(controller).on('enter', function () {
        $('.developers-step__item--desktop').css('opacity', 0.5)
        thisEl.css('opacity', 1)
      })
    })
  }
})

function myFunction () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_1').addClass('link-active')
  $('#symfony-developers').css('opacity', 1)
}

function myFunction2 () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_2').addClass('link-active')
  $('#oxid-developers').css('opacity', 1)
}

function myFunction3 () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_3').addClass('link-active')
  $('#wordpress-developers').css('opacity', 1)
}

function myFunction4 () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_4').addClass('link-active')
  $('#php-developers').css('opacity', 1)
}

function myFunction5 () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_5').addClass('link-active')
  $('#fullstack-developers').css('opacity', 1)
}

function myFunction6 () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_6').addClass('link-active')
  $('#react-developers').css('opacity', 1)
}

function myFunction7 () {
  $('.developers-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#developers-scroll_7').addClass('link-active')
  $('#javascript-developers').css('opacity', 1)
}